'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.UNAUTHENTICATED = exports.AUTHENTICATED = undefined;
exports.default = sessionRefresh;
exports.getCurrentSession = getCurrentSession;
exports.deleteCurrentSession = deleteCurrentSession;
var _throttle = require('lodash/throttle');
var _throttle2 = _interopRequireDefault(_throttle);
var _events = require('events');
var _events2 = _interopRequireDefault(_events);
var _promiseQueue = require('@energysavvy/promise-queue');
var _promiseQueue2 = _interopRequireDefault(_promiseQueue);
var _customerUiFetchActions = require('@energysavvy/customer-ui-fetch-actions');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AUTHENTICATED = exports.AUTHENTICATED = 'authenticated';
var UNAUTHENTICATED = exports.UNAUTHENTICATED = 'unauthenticated';
var FAILURE = exports.FAILURE = 'failure';
var THROTTLE_WAIT_MS = 60 * 1000;
var AUTH_URL = '/auth/sessions/current';
var USER_INITIATED_EVENTS = ['click',
// Left and right click
'keydown', 'scroll', 'touchstart', 'wheel'];
var sessionRefreshEmitter = null;
var REQUEST_QUEUE = new _promiseQueue2.default();
var GET_CURRENT_SESSION_REQUEST_ID = 'get_current_session';
var DELETE_CURRENT_SESSION_REQUEST_ID = 'delete_current_session';
var throttledGetCurrentSession = (0, _throttle2.default)(getCurrentSession, THROTTLE_WAIT_MS, {
  leading: true,
  trailing: true
});

/**
 * @returns {EventEmitter} singleton EventEmitter which tracks user interactions
 * and emits events related to session state.
 */
function sessionRefresh() {
  if (sessionRefreshEmitter === null) {
    sessionRefreshEmitter = new _events2.default();
    attachListeners(throttledGetCurrentSession);
  }
  return sessionRefreshEmitter;
}

/**
 * Attach listeners to the user-initiated events.
 *
 * @param {Function} callback function to be invoked upon user action. Function must provide a cancel() method
 *
 * @private
 */
function attachListeners(callback) {
  USER_INITIATED_EVENTS.forEach(function (eventName) {
    return document.addEventListener(eventName, callback);
  });

  // Just before closing the window, make sure to cancel any delayed calls.
  // Since the page is unloading anyways, any listeners are about to be
  // removed from the page in the first place
  window.addEventListener('beforeunload', function () {
    callback.cancel();
  });
}

/**
 * Directly trigger session retrieval, emitting the correct events as a result.
 *
 * @returns {Promise} promise for HTTP request
 */
function getCurrentSession() {
  return REQUEST_QUEUE.add(function () {
    return (0, _customerUiFetchActions.get)(AUTH_URL).then(function (data) {
      sessionRefresh().emit(AUTHENTICATED, data.expiration, data);
    }, function (error) {
      if (error instanceof _customerUiFetchActions.errors.ClientError) {
        sessionRefresh().emit(UNAUTHENTICATED);
      } else {
        sessionRefresh().emit(FAILURE);
      }
    });
  }, GET_CURRENT_SESSION_REQUEST_ID).catch(function (error) {
    if (error.constructor !== _promiseQueue.ItemCleared) {
      throw error;
    }
  });
}
function deleteCurrentSession() {
  REQUEST_QUEUE.clear();
  return REQUEST_QUEUE.add(function () {
    return (0, _customerUiFetchActions.del)(AUTH_URL);
  }, DELETE_CURRENT_SESSION_REQUEST_ID).catch(function (error) {
    if (error.constructor !== _promiseQueue.ItemCleared) {
      throw error;
    }
  });
}